// extracted by mini-css-extract-plugin
module.exports = {"title":"hero_title__I3pzK","subtitle":"hero_subtitle__Ibz_q"};